import CopyLinkModal from '../../components/modals/CommunityCopyLinkModal'
import ExtraOptionsModal from '../../components/modals/ExtraOptionsModal'
import NotificationCancelEventModal from '../../components/modals/NotificationCancelEventModal'
import NotificationSwitchEventModal from '../../components/modals/NotificationSwitchEventModal'
import PolicyModal from '../../components/modals/PolicyModal'
import handleToast from '../../components/toast/handleToast'

import EventJoinedCard from '../../components/cards/EventJoinedCard'

import { Box, Button, Center, Flex, Icon, IconButton, Spacer, Text, useDisclosure, useToast } from '@chakra-ui/react'

import { Calendar, EventsRacket, List } from '../../components/icons/icons'
import { useUserWrapperContext } from '../../components/wrappers/UserWrapper'

import { useContext, useEffect, useState } from 'react'
import { useInfiniteQuery, useMutation, useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { deleteJoin, getUpcomingEvents, patchSwitchEvent, postInvite } from '../../api/user/notifications/Notifications'
import { AuthContext } from '../../App'
import CalendarDisplay from '../../components/calendar/Calendar'
import InfinityGrid, { getInfinityPages } from '../../components/datagrid/InfinityGrid'
import ShareModal from '../../components/modals/ShareModal'
import { getSkillLevelDisplay } from '../../functions/Capitalize'
import { getEventLabel } from '../../types/EventTypes'

import CustomTabsFilled from '../../components/input/CustomTabsFilled'
import PrivateClassJoinedCard from '../../components/cards/PrivateClassJoinedCard'

// const SKILL_LEVELS: any = ['Beginner', 'Intermediate', 'Intermediate High', 'Advanced', 'Advanced 4.5+', 'Mixed-Level']

// const formatDateTime = (date: Date): string => {
//     const today = new Date();
//     const tomorrow = new Date(today);

//     const isToday = date.toDateString() === today.toDateString()
//     const isTomorrow = date.toDateString() === tomorrow.toDateString()
//     const longOptions: Intl.DateTimeFormatOptions = {
//         day: 'numeric',
//         month: 'long',
//         hour: 'numeric',
//         minute: 'numeric',
//     };

//     const shortOptions: Intl.DateTimeFormatOptions = {
//         hour: 'numeric',
//         minute: 'numeric',
//     };

//     tomorrow.setDate(today.getDate() + 1);
//     tomorrow.setHours(12, 30, 0, 0);

//     if (isToday) {
//         return `Today, ${date.toLocaleTimeString('en-US', shortOptions)}`;
//     } else if (isTomorrow) {
//         return `Tomorrow, ${date.toLocaleTimeString('en-US', shortOptions)}`;
//     } else {
//         return date.toLocaleDateString('en-US', longOptions);
//     }
// };

export const EXAMPLE_POLICY = [
  {
    title: 'Entry 1',
    description: 'This is the first entry.',
  },
  {
    title: 'Entry 2',
    description: 'This is the second entry.',
  },
  {
    title: 'Entry 3',
    description: 'This is the third entry.',
  },
  {
    title: 'Entry 4',
    description: 'This is the fourth entry.',
  },
  {
    title: 'Entry 5',
    description: 'This is the fifth entry.',
  },
  {
    title: 'Entry 6',
    description: 'This is the sixth entry.',
  },
  {
    title: 'Entry 6',
    description: 'This is the sixth entry.',
  },
  {
    title: 'Entry 6',
    description: 'This is the sixth entry.',
  },
  {
    title: 'Entry 6',
    description: 'This is the sixth entry.',
  },
  {
    title: 'Entry 6',
    description: 'This is the sixth entry.',
  },
]

export function isSameDay(date1: Date, date2: Date | null): boolean {
  if (date2 == null) {
    return false
  }

  if (
    date1.getFullYear() === date2?.getFullYear() &&
    date1.getMonth() === date2?.getMonth() &&
    date1.getDate() === date2?.getDate()
  ) {
    return true
  }

  return false
}

const EventsSection = ({
  isTablet,
  isSmallTablet,
  isMobile,
  events,
  isShareOpen,
  onShareClose,
  onShareOpen,
  currentEventId,
  setCurrentEventId,
}: {
  isTablet: boolean
  isSmallTablet?: boolean
  isMobile?: boolean
  events: any
  onShareOpen: () => void
  onShareClose: () => void
  isShareOpen: boolean
  currentEventId: string
  setCurrentEventId: (v: string) => void
}) => {
  const { notificationScreen, setNotificationScreen } = useUserWrapperContext()
  const toast = useToast()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const [eventTab, setEventTab] = useState(0) // 0=Upcoming, 1=Past
  const isPast = eventTab === 1

  const pastEvents = useInfiniteQuery(
    ['pastEvents'],
    ({ pageParam = 1 }) =>
      getUpcomingEvents({
        max_date: new Date().toISOString(),
        page: pageParam,
        page_size: 10,
      }),
    {
      enabled: isPast,
      staleTime: 0,
      refetchOnMount: 'always',
      refetchOnWindowFocus: true,
      getNextPageParam: (lastPage) => {
        if (!lastPage?.hasNext) return null
        return lastPage.nextCursor
      },
    }
  )

  const activeEvents = isPast ? pastEvents : events

  useEffect(() => {
    if (isPast) {
      setNotificationScreen('events')
    }
  }, [isPast])

  const { isOpen: isCopyLinkOpen, onOpen: onOpenCopyLink, onClose: onCloseCopyLink } = useDisclosure()
  const { isOpen: isExtraOptionsOpen, onOpen: onExtraOptionsOpen, onClose: onExtraOptionsClose } = useDisclosure()
  const { isOpen: isSwitchEventOpen, onOpen: onSwitchEventOpen, onClose: onSwitchEventClose } = useDisclosure()
  const { isOpen: isCancelEventOpen, onOpen: onCancelEventOpen, onClose: onCancelEventClose } = useDisclosure()
  const { isOpen: isRefundPolicyOpen, onOpen: onRefundPolicyOpen, onClose: onRefundPolicyClose } = useDisclosure()

  const exitEvent = useMutation(['deleteJoin'], deleteJoin, {
    onSuccess: () => {
      onCancelEventClose()
      handleToast(toast, 'Event cancelled!')
      queryClient.invalidateQueries(['upcomingEvents'])
    },
    onError: () => handleToast(toast, 'An error has occured while attempting to cancel an event'),
  })

  const { setIsHost, user } = useContext(AuthContext)
  const [currentEvent, setCurrentEvent] = useState<any>(null)

  // const [ currentEventId, setCurrentEventId ] = useState<string>("")

  const switchEvent = useMutation(['switchEvent'], patchSwitchEvent, {
    onSuccess: (_: any, variables) => {
      const { to_event_id } = variables.data
      onSwitchEventClose()
      queryClient.invalidateQueries(['upcomingEvents'])
      navigate('/user/notifications/switch/success?event_id=' + to_event_id)
    },
    onError: () => handleToast(toast, 'An error has occured while attempting to switch an event'),
  })

  const onSwitch = (id: string) => {
    switchEvent.mutate({
      id: currentEventId,
      data: {
        to_event_id: id,
      },
    })
  }

  const handleOpenCopyLink = () => {
    if (isMobile) {
      navigator.share({
        title: currentEvent?.title || 'LVBL',
        text: `Check out ${currentEvent?.title || 'this event'} on LVBL!`,
        url: `${import.meta.env.VITE_LOCAL_ENDPOINT}/event/${currentEventId}`,
      })
    } else {
      onOpenCopyLink()
    }
  }

  // const shareToInstagram = () => {

  //     const event_id = currentEventId
  //     const event = getInfinityPages(events,"events").find((event:any) => event.id === event_id)
  //     const image_url = (event.venue.images.length > 0) ? event.venue.images[0] : ""
  //     const caption = `Join me at ${event.title} on ${new Date(event.start_time).toLocaleString('en-US', {
  //         weekday: 'long',
  //         month: 'long',
  //         day: 'numeric',
  //     })}!`

  //     const instagramUrl = `instagram://library?AssetPath=${encodeURIComponent(image_url)}&InstagramCaption=${encodeURIComponent(caption)}`

  //     window.location.href = instagramUrl

  //     // setTimeout(() => {
  //     //     window.location.href = `https://www.instagram.com`
  //     // }, 1000)
  // }

  const isApp = () => {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  }

  const inviteMutation = useMutation(['invite'], postInvite, {
    onSuccess: () => {
      onShareClose()
      handleToast(toast, 'Invitation sent succesfully')
    },
    onError: () => {
      handleToast(toast, 'An error has occured while sending your invitation. Please try again.')
    },
  })

  const onInvite = (members: string[]) => {
    members.forEach((member: string) => {
      inviteMutation.mutate({ id: currentEventId, data: { member } })
    })
    onExtraOptionsClose()
  }

  return (
    <>
      <PolicyModal
        isOpen={isRefundPolicyOpen}
        onClose={onRefundPolicyClose}
        header="Refund policy"
        content={EXAMPLE_POLICY}
      />
      <CopyLinkModal
        link={`/event/${currentEventId}`}
        isOpen={isCopyLinkOpen}
        onClose={onCloseCopyLink}
        onCopyLink={() => {
          navigator.clipboard.writeText(
            `${import.meta.env.VITE_LOCAL_ENDPOINT}/event/${currentEventId}`
          )
          handleToast(toast, 'Link copied to clipboard!')
          onCloseCopyLink()
        }}
        caption={`Check out ${currentEvent?.title || 'this event'} on LVBL!`}
      />
      <NotificationCancelEventModal
        isOpen={isCancelEventOpen}
        onClose={onCancelEventClose}
        onConfirm={() => exitEvent.mutate({ id: currentEventId })}
        onOpenRefundPolicy={onRefundPolicyOpen}
        isLoading={exitEvent.isLoading}
      />
      <NotificationSwitchEventModal
        isOpen={isSwitchEventOpen}
        onClose={onSwitchEventClose}
        eventId={currentEventId}
        onSwitch={(id: string) => onSwitch(id)}
        isTablet={isTablet}
        isMobile={isMobile ?? false}
        isLoading={switchEvent.isLoading}
      />

      <ShareModal isOpen={isShareOpen} onClose={onShareClose} onShare={onInvite} title="Share with friends" />

      <ExtraOptionsModal
        isOpen={isExtraOptionsOpen}
        onClose={onExtraOptionsClose}
        buttons={
          isApp()
            ? [
                { text: 'Share outside LVBL', onClick: handleOpenCopyLink, isRed: false },
                { text: 'Share with friends', onClick: () => onShareOpen(), isRed: false },
                //{ text:'Share on Instagram', onClick:() => shareToInstagram(), isRed:false },
                { text: 'Cancel', onClick: onExtraOptionsClose, isRed: true },
              ]
            : [
                { text: 'Share outside LVBL', onClick: handleOpenCopyLink, isRed: false },
                { text: 'Share with friends', onClick: () => onShareOpen(), isRed: false },
                { text: 'Cancel', onClick: onExtraOptionsClose, isRed: true },
              ]
        }
      />
      {!isSmallTablet && !isMobile && (
        <Flex p="20px 20px 0 20px" alignItems="center" justifyContent="space-between">
          <Flex gap="5px" alignItems="center">
            <Icon w="24px" h="24px" viewBox="0 0 24 24">
              <Calendar />
            </Icon>
            <Text variant="title">My Events</Text>
          </Flex>
          <Flex gap="8px" alignItems="center">
            <CustomTabsFilled
              name="eventTab"
              value={eventTab}
              onChange={setEventTab}
              choices={['Upcoming', 'Past']}
            />
            {(notificationScreen === 'events' || notificationScreen === 'notifications') ? (
              <IconButton
                minW="32px"
                h="32px"
                variant="light"
                aria-label="back"
                isDisabled={isPast}
                onClick={() => {
                  setNotificationScreen('calendar')
                }}
                icon={
                  <Icon width="20px" height="20px" viewBox="0 0 24 24" color={isPast ? '#A0AEC0' : '#171C22'}>
                    <Calendar />
                  </Icon>
                }
              />
            ) : (
              <IconButton
                minW="32px"
                h="32px"
                variant="light"
                aria-label="back"
                onClick={() => setNotificationScreen('events')}
                icon={
                  <Icon width="18px" height="18px" viewBox="0 0 20 15">
                    <List color="#171C22" />
                  </Icon>
                }
              />
            )}
          </Flex>
        </Flex>
      )}

      {(notificationScreen === 'events' || notificationScreen === 'notifications') && (
        <Box p={isMobile ? '20px' : isSmallTablet ? 0 : '20px 20px 0 20px'}>
          {(isSmallTablet || isMobile) && (
            <Box mb="12px">
              <CustomTabsFilled
                name="eventTabMobile"
                value={eventTab}
                onChange={setEventTab}
                choices={['Upcoming', 'Past']}
                w="fit-content"
              />
            </Box>
          )}
          {activeEvents.isLoading &&
            [1, 1, 1, 1].map((_, index) => {
              return (
                <EventJoinedCard
                  key={index}
                  onSwitchTime={() => {}}
                  onCancel={() => {}}
                  onSwitchSelect={() => {}}
                  onExtraOptionsOpen={() => {}}
                  isTablet={isTablet}
                  host={{
                    id: '12345',
                    name: 'John Doe',
                    avatar: 'url/to/avatar.jpg',
                  }}
                  coach={[]}
                  players={[]}
                  title="Le Parc"
                  time={new Date()}
                  type="Private Lesson"
                  court="Some Court"
                  level="Beginner"
                  location="Some Location"
                  duration={60}
                  isCancelled={false}
                  isCollapsed
                  thumbnail="/temp/event1.png"
                  isSkeleton
                />
              )
            })}

          {getInfinityPages(activeEvents, 'events').length == 0 ? (
            <Center w="100%" flexDir="column" gap="20px" mt="40px">
              <Icon w={isMobile ? 202 : 323} h={isMobile ? 154 : 246} viewBox="0 0 323 246">
                <EventsRacket />
              </Icon>
              <Text color="#171C22" fontWeight="400" fontSize="md">
                {isPast ? 'You have no past events' : 'You have no upcoming events'}
              </Text>
              {!isPast && (
                <Button
                  variant="heavy"
                  onClick={() => {
                    setIsHost(false)
                    navigate('/user/play')
                  }}
                >
                  Find events
                </Button>
              )}
            </Center>
          ) : (
            <InfinityGrid
              isLoading={activeEvents.isLoading}
              isFetchingNextPage={activeEvents.isFetchingNextPage}
              hasNextPage={activeEvents.hasNextPage ?? false}
              onLoadMore={() => activeEvents.fetchNextPage()}
            >
              {getInfinityPages(activeEvents, 'events').map((event: any, index: number) => {
                return (
                  <Box key={index}>
                    {index === 0 ||
                    !isSameDay(
                      new Date(event.start_time),
                      new Date(getInfinityPages(activeEvents, 'events')[index - 1].start_time)
                    ) ? (
                      <Text variant="title" fontSize="17px" mb="4px" mt="20px">
                        {new Date(event.start_time).toLocaleString('en-US', {
                          weekday: 'long',
                          month: 'long',
                          day: 'numeric',
                        })}
                      </Text>
                    ) : (
                      <Spacer h="20px" />
                    )}

                    {event.type == 'private_class' ? (
                      <>
                        <PrivateClassJoinedCard
                          id={event.id}
                          package_id={event.package_id}
                          isTablet={isTablet}
                          isPast={isPast}
                          coach={event.coach}
                          duration={event.duration}
                          time={event.start_time}
                          type={event.type}
                          onExtraOptionsOpen={() => {
                            setCurrentEventId(event.id)
                            onExtraOptionsOpen()
                          }}
                        />
                      </>
                    ) : (
                      <EventJoinedCard
                        onSwitchTime={() => {
                          if (!isPast) {
                            setCurrentEventId(event.id)
                            onSwitchEventOpen()
                          }
                        }}
                        onCancel={() => {
                          if (!isPast) {
                            setCurrentEventId(event.id)
                            onCancelEventOpen()
                          }
                        }}
                        onSwitchSelect={() => {}}
                        onExtraOptionsOpen={() => {
                          setCurrentEventId(event.id)
                          setCurrentEvent(event)

                          onExtraOptionsOpen()
                        }}
                        isTablet={isTablet}
                        host={{
                          id: event.host?.id,
                          name: event.host?.display_name,
                          avatar: event.host?.profile_image,
                        }}
                        coach={event.coaches.map((coach: any) => {
                          return {
                            id: coach.id,
                            name: coach.display_name,
                            avatar: coach.profile_image,
                          }
                        })}
                        players={event.participants.map((participant: any) => {
                          return {
                            id: participant.id,
                            name: participant.display_name,
                            avatar: participant.profile_image,
                            checked_in: participant.checked_in,
                          }
                        })}
                        title={event.title}
                        time={new Date(event.start_time)}
                        type={getEventLabel(event.type)}
                        court={event.court}
                        level={getSkillLevelDisplay(event.skill_level)}
                        location={event.venue.name}
                        address={event.venue.address}
                        duration={event.duration}
                        isCancelled={event?.status?.status === 'cancelled'}
                        status={event?.status?.status}
                        thumbnail={event?.venue?.images?.length > 0 ? event.venue.images[0] : ''}
                        eventId={event.id}
                        isHostOrCoach={
                          event.host?.id === user?.member_profile?.id ||
                          event.coaches?.some((c: any) => c.id === user?.member_profile?.id)
                        }
                      />
                    )}
                  </Box>
                )
              })}
            </InfinityGrid>
          )}
        </Box>
      )}

      {notificationScreen === 'calendar' && !isPast && (
        <Box p="20px">
          <CalendarDisplay
            events={{ events: getInfinityPages(events, 'events') ?? [] }}
            onShareOpen={onShareOpen}
            setCurrentEventId={setCurrentEventId}
          />
        </Box>
      )}
    </>
  )
}

export default EventsSection
